import { isAfter, subMonths } from 'date-fns';
import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';

// November 3, 2020 is the oldest allowed date for quotation cloning
export const OLDEST_ALLOWED_DATE = new Date(2020, 10, 3);

export default function shouldShowEditButton(
  summary: QuotationSummaryResponse,
): boolean {
  const summaryDate = new Date(summary.quotationDate);
  return (
    isAfter(summaryDate, OLDEST_ALLOWED_DATE) &&
    isAfter(summaryDate, subMonths(new Date(), 6)) &&
    summary.insuranceValue <= -1
  );
}
